<script setup lang="ts">
  import { computed } from 'vue'

  type MessageType = 'info' | 'warning' | 'error' | 'success'
  type MessageConfig = { icon: string[]; border: string; background: string; color: string }

  const props = defineProps<{
    type?: MessageType
    onClose?: () => void
  }>()

  const emits = defineEmits<{
    close: []
  }>()

  const configMap: Record<MessageType, MessageConfig> = {
    info: {
      icon: ['fa-light', 'fa-info-circle'],
      background: 'bg-blue-97',
      border: 'border-blue-50',
      color: 'text-blue-50',
    },
    warning: {
      icon: ['fa-light', 'fa-exclamation-circle'],
      background: 'bg-orange-97',
      border: 'border-orange-50',
      color: 'text-orange-50',
    },
    error: {
      icon: ['fa-light', 'fa-times-circle'],
      background: 'bg-red-97',
      border: 'border-red-50',
      color: 'text-red-50',
    },
    success: {
      icon: ['fa-light', 'fa-check-circle'],
      background: 'bg-green-97',
      border: 'border-green-50',
      color: 'text-green-50',
    },
  }

  const config = computed<MessageConfig>(() => configMap[props.type ?? 'info'])
</script>

<template>
  <div
    class="flex shrink-0 items-center gap-2 rounded-sm p-4 min-h-16 text-sm border"
    :class="[config.border, config.background]"
  >
    <div class="shrink-0 rounded-sm p-1 flex items-center justify-center">
      <des-icon :icon="config.icon" class="w-icon h-icon" :class="config.color" />
    </div>
    <div class="grow flex gap-3">
      <slot></slot>
    </div>
    <div
      v-if="onClose"
      @click="emits('close')"
      class="cursor-pointer w-5 h-5 text-xl text-black-40 rounded-sm hover:bg-white-gray leading-none self-start flex items-top mt-1 shrink-0"
    >
      <des-icon icon="fa-light fa-times" class="w-icon h-icon pointer-events-none" />
    </div>
  </div>
</template>
